import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"

const Objective13AiServicesOrganism = () => {
  return (
    <div className="Verdikt-Score">
      <div className={classNames("environmental", "page-frame")}>
        <div className={classNames("page")}>
          <div
            className={classNames(
              "environmental",
              "widget",
              "chart",
              "transparent-widget"
            )}
          >
            <MetabaseChartMolecule
              verdikt_alias={"dashboard_understand_ai_services"}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

Objective13AiServicesOrganism.propTypes = {
  score: PropTypes.object.isRequired,
}

Objective13AiServicesOrganism.defaultProps = {}

export default Objective13AiServicesOrganism
